//import './stylesheets/default/MenuBar.css';
import './stylesheets/flat/MenuBarFlat.css'
import './stylesheets/neumorphism/MenuBarNeumorphism.css'
import './stylesheets/neobrutalism/MenuBarNeobrutalism.css'
import './stylesheets/glassmorphism/MenuBarGlassmorphism.css'


function MenuBar({style, setStyle}){
    
    const changeStyle = (newStyle) => {
        setStyle(newStyle);
    };
  return (
    <div className={`menu-bar-${style}`}>
      <button className={`menu-button-${style}`} onClick={() => changeStyle("flat")}>Flat</button>
      <button className={`menu-button-${style}`} onClick={() => changeStyle("neumorphism")}>Neumorphism</button>
      <button className={`menu-button-${style}`} onClick={() => changeStyle("neobrutalism")}>Neobrutalism</button>
      <button className={`menu-button-${style}`} onClick={() => changeStyle("glassmorphism")}>Glassmorphism</button>
    </div>
  );
}

export default MenuBar